import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';
import { InputContainer } from '../styles';

interface InputTimeProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  isError: boolean;
  control: Control<FieldValues, any>;
}

export const InputTime: React.FC<InputTimeProps> = ({
  label = '',
  placeholder = '',
  name,
  register,
  isError,
  control,
  ...rest
}) => {
  return (
    <>
      <InputContainer>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <input
                  {...register(name)}
                  type="time"
                  className={
                    isError ? 'form-control is-invalid' : 'form-control'
                  }
                  value={value || ''}
                  placeholder={placeholder}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChange(event.target.value);
                  }}
                  {...rest}
                />
              );
            }}
          />
        </Form.Group>
      </InputContainer>
    </>
  );
};
